// @flow
import styled from 'styled-components';
import { H3 } from '@finect/tabular-core/Headings';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

// Envoltorio de las landings (asesores e hipotecas): acota el ancho de los H3 en tablet.
/* eslint-disable */
export const LandingContent = styled.div`
  ${/* sc-sel */ H3} {
    ${maxMediaQueries.tablet`
      max-width: 528px;
    `};
  }
`;
/* eslint-enable */
